<template>
  <div class="business">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="2"></menuBox>
      <div class="banner-text">
        <div class="title">Memimpin masa depan kreatif</div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI adalah perusahaan periklanan dan perencanaan media terkemuka yang berlokasi di Jakarta, Indonesia. Kami fokus pada penyediaan berbagai solusi periklanan, termasuk desain kreatif, perencanaan media, dan produksi periklanan
        </div>
      </div>
    </div>
    <div class="banner-list">
      <img src="../assets/banner-list.png" alt="">
    </div>
    <div class="text-box">
      <div class="title">
        Keuntungan kami
      </div>
      <div class="content">
        <div class="item">
          PT LAYAR CERITA IMAJINASI dikenal dengan kemampuan desain kreatif dan perencanaan media yang sangat baik. Kami memiliki tim yang berpengalaman dan kreatif yang mampu memberikan solusi periklanan lengkap kepada klien mulai dari konsep hingga pelaksanaan. Melalui analisis pasar yang tepat dan pembelian media yang strategis, kami memastikan bahwa penempatan iklan klien kami memaksimalkan dampak dan jangkauannya.
        </div>
        <div class="item">
          Berkomitmen terhadap kepuasan pelanggan, kami memperhatikan setiap detail untuk memastikan bahwa setiap proyek memenuhi atau melampaui harapan pelanggan. Kami menyediakan layanan yang dipersonalisasi dan menyesuaikan strategi periklanan berdasarkan positioning merek klien kami dan kebutuhan pasar. Eksekusi kami yang efisien dan pendekatan inovatif telah menempatkan kami pada posisi terdepan dalam industri, mendapatkan kepercayaan dan kerja sama jangka panjang dari banyak pelanggan.
        </div>
      </div>
    </div>
    <div class="mission-box">
      <img src="../assets/mession-1.png" alt="" />
      <div class="content">
        <div class="title">
          Memberdayakan usaha kecil dan menengah
        </div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI tidak hanya menyediakan solusi perencanaan periklanan profesional untuk perusahaan besar, namun juga berkomitmen untuk mendukung pengembangan usaha kecil dan menengah. Kami telah mengembangkan program preferensi khusus untuk usaha kecil dan menengah untuk membantu mereka mencapai promosi merek dan perluasan pasar. Kami berharap dapat menyaksikan pertumbuhan dan kesuksesan lebih banyak usaha kecil dan menengah melalui layanan profesional kami.
        </div>
      </div>
    </div>
    <div class="plan-box">
      <div class="box-title">
        Kami bersedia untuk tumbuh bersama perusahaan
      </div>
      <div class="list">
        <div class="item">
          <img src="../assets/plan-1.png" alt="" />
          <div class="title">
            Solusi yang disesuaikan
          </div>
          <div class="text">
            Berdasarkan karakteristik usaha kecil dan menengah, rumuskan rencana perencanaan periklanan yang dipersonalisasi untuk meningkatkan pengaruh merek.
          </div>
        </div>
        <div class="item">
          <img src="../assets/plan-2.png" alt="" />
          <div class="title">
            Dukungan preferensial
          </div>
          <div class="text">
            Memberikan paket preferensi eksklusif untuk mengurangi biaya investasi periklanan dan mencapai publisitas yang efisien.
          </div>
        </div>
        <div class="item">
          <img src="../assets/plan-3.png" alt="" />
          <div class="title">
            Pelayanan penuh
          </div>
          <div class="text">
            Dari desain kreatif hingga penempatan media, dukungan profesional diberikan di seluruh proses untuk memastikan efektivitas iklan yang maksimal.
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="team-box">
      <div class="title">
        Our professional team
      </div>
      <div class="list">
        <div class="item">
          Solution team <br />
          We have an experienced solutions team who are proficient in financial
          products and market dynamics and can tailor the most appropriate loan
          solutions according to customer needs and situations to ensure that
          users can receive the best quality services and benefits.
        </div>
        <div class="item">
          Operations team <br />
          Our operations team is committed to ensuring the smooth operation of
          services and the continuous optimization of user experience. They pay
          close attention to user feedback and market changes, constantly
          optimize products and services, and improve user satisfaction and
          loyalty.
        </div>
      </div>
    </div> -->
    <div class="mission-box mission-box-1">

      <div class="content">
        <div class="title">
          Meningkatkan efektivitas periklanan dan meningkatkan konversi pembelian
        </div>
        <div class="text">
          Melalui perencanaan dan periklanan perusahaan, di era media baru, perusahaan ini telah meningkatkan kekuatan konversi pembelian pelanggan rata-rata hampir 40%, dan telah memenangkan pujian dengan suara bulat dari pelanggan.
        </div>
        <div class="list">
          <div class="item">
            <h4>5000K+</h4>
            <p>
              Tampilan
            </p>
          </div>
          <div class="item">
            <h4>92%</h4>
            <p>
              Tingkat konversi produk
            </p>
          </div>
        </div>
      </div>
      <img src="../assets/mession-2.png" alt="" />
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {
      aboutUs() {
        this.$router.push({ path: "aboutUs" });
      },
    },
  };
</script>
<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-2.png);
    height: 500px;
    background-size: 100% 100%;

    .banner-text {
      margin: 0 360px;
      padding-top: 100px;
      text-align: center;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 64px;
        color: #333333;
      }

      .text {
        font-size: 26px;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .banner-list {
    padding: 0 360px;
    margin-top: -100px;

    img {
      width: 100%;
    }
  }

  .text-box {
    padding: 120px 360px;

    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      width: 1000px;
      color: #252B42;
      margin-bottom: 50px;
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item {
        width: 550px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #737373;
      }
    }
  }

  .mission-box {
    padding: 150px 360px;
    padding-top: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .content {
      width: 650px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 46px;
        color: #252B42;
        margin: 17px 50px;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #737373;
        margin: 0px 50px;
        border-left: 7px solid #FCDB67;
        padding-left: 20px;
      }
    }

    img {
      width: 534px;
      height: 359px;
    }
  }

  .plan-box {
    padding: 100px 360px;

    padding-top: 0;

    .box-title {
      padding: 0 200px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
      text-align: center;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;

      .item {
        text-align: center;
        width: 500px;

        img {
          width: 150px;
          height: 130px;
          margin-top: 36px;
        }

        .title {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 25px;
          color: #333333;
          margin: 17px 0;
        }

        .text {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          margin: 0px 20px;
        }
      }
    }
  }

  .number-box {
    padding: 120px 360px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #ffd808;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 46px;
    color: #333333;
  }

  .team-box {
    padding: 0 360px;
    padding-bottom: 100px;

    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 46px;
      color: #333333;
      margin-top: 150px;
      text-align: center;
    }

    .list {
      display: flex;
      justify-content: space-around;
      margin-top: 80px;

      .item {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        width: 500px;
      }
    }
  }

  .mission-box-1 {
    background-color: #FCDB67;
    padding-bottom: 80px;
    img {
      width: 520px;
      height: 503px;
      margin-top: 80px;
    }
    
    .content {
      margin-top: 50px;
      .title{
        margin: 0;
        margin-bottom: 20px;
        width: 500px;
        font-size: 46px;
      }
      .text {
        width: 500px;
        padding: 0;
        margin: 0;
      }
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 200px;
      margin-top: 50px;
      .item {
        border-left:4px solid  rgba(122, 122, 122, .3);
        padding-left: 20px;
        h4 {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 42px;
          color: #252B42;
        }

        p {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 18px;
          color: #7A7A7A;
        }
      }
    }
  }
</style>